// Module
var code = "<div class=\"cloud-wrapper\" id=\"content\">\n    <p style=\"text-align: center;\">{{ name }}</p>\n    <div id=\"cloud\"></div>\n</div>";
// Exports
module.exports = code;